import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';

export default function CampaignSendModal({ show, campaign, audienceSummary, onClose, onSent }) {
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);

    const handleSend = async () => {
        setSending(true);
        setError(null);
        try {
            await axios.post(`/api/campaigns/${campaign.id}/send/`, {}, { withCredentials: true });
            onSent();
        } catch (err) {
            setError(err.response?.data?.detail || 'Send failed. Please try again.');
            setSending(false);
        }
    };

    if (!campaign) return null;

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Send campaign</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-2">
                    <strong>{campaign.title}</strong>
                </p>
                <p className="text-muted small mb-3">Subject: {campaign.subject}</p>
                <table className="table table-sm table-borderless mb-3">
                    <tbody>
                        <tr>
                            <th className="text-muted fw-normal small">From</th>
                            <td>{campaign.from_email || '—'}</td>
                        </tr>
                        <tr>
                            <th className="text-muted fw-normal small">Recipients</th>
                            <td className="fw-bold">{audienceSummary?.included ?? '—'}</td>
                        </tr>
                        <tr>
                            <th className="text-muted fw-normal small">Scheduled for</th>
                            <td>{campaign.scheduled_for
                                ? new Date(campaign.scheduled_for).toLocaleString()
                                : 'Immediately'}
                            </td>
                        </tr>
                        <tr>
                            <th className="text-muted fw-normal small">Batch size</th>
                            <td>{campaign.batch_size} / {campaign.send_rate_per_minute} per min</td>
                        </tr>
                    </tbody>
                </table>
                {error && <div className="alert alert-danger small py-2">{error}</div>}
                <p className="small text-muted mb-0">
                    This will queue the campaign for delivery through the configured email backend. This action cannot be undone.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={sending}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSend} disabled={sending}>
                    {sending ? 'Queuing…' : 'Queue send'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
